/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {buildFloatAttributeValidation, getDisplayText} from './commons';
import {
    EntityAttribute,
    EntityAttributeProps,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
} from './EntityAttribute';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';

/**
 * The default props for a float entity attribute
 */
export const FLOAT_ENTITY_ATTRIBUTE_DEFAULT_PROPS = {
    ...ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    validateValue: buildFloatAttributeValidation(undefined, undefined),
    onFieldInputEnded: (component: EntityAttribute, input: string) => {
        if (
            input.length === 0 &&
            !component.props.isRequired(component.props.attribute)
        ) {
            // the new value is empty and not required
            // => convert to unset value
            return component.props.onFieldEditedValue(component, null);
        }
        try {
            let value = Number.parseFloat(input);
            component.props.onFieldEditedValue(component, value);
        } catch (error) {
            // not a number?
            component.props.onFieldEditedValue(component, input);
        }
    },
    renderInput: (component: EntityAttribute) => {
        let text = getDisplayText(component.state.value);
        return (
            <input
                type={'number'}
                disabled={component.props.disabled}
                required={component.props.isRequired(component.props.attribute)}
                value={text}
                onChange={(event) =>
                    component.props.onFieldChange(component, event)
                }
                onBlur={(event) =>
                    component.props.onFieldBlur(component, event)
                }
            />
        );
    },
};

/**
 * Component for rendering a float entity attribute
 */
export class FloatEntityAttribute extends React.Component<EntityAttributeProps> {
    public static defaultProps = FLOAT_ENTITY_ATTRIBUTE_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
